<div
  class="min-h-screen flex flex-col items-center justify-center p-6 sm:p-12 lg:p-24 animate-in fade-in slide-in-from-right-4 duration-500">
  <div class="text-center mb-12">
    <h2 class="text-3xl font-bold text-navy mb-3">Quel est votre rôle ?</h2>
    <p class="text-gray-500 text-lg">Choisissez comment vous souhaitez utiliser BAILIA.</p>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl">
    <button (click)="handleProfileChoice('landlord')"
            class="group relative flex flex-col items-center p-8 bg-white border-2 border-gray-100 rounded-3xl hover:border-navy hover:shadow-xl transition-all duration-300 text-center">
      <div
        class="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <ng-icon name="lucideBuilding2" size="48" color="var(--navy)"/>
      </div>
      <h3 class="text-xl font-bold text-navy mb-2">Propriétaire</h3>
      <p class="text-sm text-gray-500 leading-relaxed px-4">
        Gérez vos biens, suivez vos loyers et trouvez des locataires fiables.
      </p>
      <div
        class="mt-6 px-6 py-2 bg-gray-50 rounded-full text-sm font-medium text-navy group-hover:bg-navy group-hover:text-white transition-colors">
        Choisir cet espace
      </div>
    </button>

    <button (click)="handleProfileChoice('tenant')"
            class="group relative flex flex-col items-center p-8 bg-white border-2 border-gray-100 rounded-3xl hover:border-emerald hover:shadow-xl transition-all duration-300 text-center">
      <div
        class="w-20 h-20 bg-emerald/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <ng-icon name="lucideHome" size="48" color="var(--emerald)"/>
      </div>
      <h3 class="text-xl font-bold text-navy mb-2">Locataire</h3>
      <p class="text-sm text-gray-500 leading-relaxed px-4">
        Cherchez un logement, déposez votre dossier et payez votre loyer.
      </p>
      <div
        class="mt-6 px-6 py-2 bg-gray-50 rounded-full text-sm font-medium text-emerald group-hover:bg-emerald group-hover:text-white transition-colors">
        Choisir cet espace
      </div>
    </button>
  </div>
</div>
